exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".range-slider{display:flex;flex-direction:row;justify-content:center;align-items:center}.range-slider .title{font-weight:bold;width:50%;text-align:right}.range-slider .controls{margin-left:8px}", ""]);

